import React from 'react';
import { StyledContent, StyledFormStack, StyledHeaderStack, StyledInputsStack, StyledTitleStack, styles } from '../UnlockForm/UnlockForm.styles';
import { StyledInputWrapper } from '../shared/UnlockInputWrapper.styles';
import { FormControl, InputV2, TextV2 } from '@withjoy/joykit';
import { VerifyEmailFormController } from './VerifyEmailForm.controller';
import type { GuestTypes } from '@apps/guest/packages/layout-engine/components/UnlockDialog/UnlockDialog';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body4ToSubHeadingOverride, hed6ToSubHeadingOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { useDeferredInputFocus } from '../useDeferredInputFocus';
import { useUnlockDialogInputStyles } from '../useUnlockDialogButtonStyles';
import { UnlockSubmitButton } from '../shared/UnlockSubmitButton';

export interface VerifyEmailFormProps {
  eventId: string;
  guest: GuestTypes;
  setGuest: (p: GuestTypes) => void;
}

export const VerifyEmailForm: React.FC<VerifyEmailFormProps> = ({ eventId, guest, setGuest }) => {
  const { formik, loading, inputError, title, subtitle, emailLabel, submitButtonText, inputPlaceholder } = VerifyEmailFormController({
    eventId,
    setGuest,
    guest,
  });
  const inputRef = useDeferredInputFocus();
  const inputStyles = useUnlockDialogInputStyles();

  return (
    <StyledContent __css={styles.content}>
      <StyledHeaderStack>
        <StyledTitleStack>
          <GuestSiteTypographyOverride override={hed6ToSubHeadingOverride}>
            <TextV2 typographyVariant="hed6">{title}</TextV2>
          </GuestSiteTypographyOverride>
          <GuestSiteTypographyOverride override={body4ToSubHeadingOverride}>
            <TextV2 typographyVariant="body4">{subtitle}</TextV2>
          </GuestSiteTypographyOverride>
        </StyledTitleStack>
      </StyledHeaderStack>
      <StyledFormStack
        spacing={6}
        __css={styles.formStack}
      >
        <form onSubmit={formik.handleSubmit}>
          <StyledInputsStack>
            <StyledInputWrapper $focusColor={inputStyles.focusColor}>
              <FormControl
                label={emailLabel}
                overrides={{ Label: { props: { color: 'inherit' } } }}
              >
                <InputV2
                  ref={inputRef}
                  overrides={{ Root: { props: { borderColor: inputStyles.borderColor } } }}
                  isInvalid={(inputError && formik.touched.email) || undefined}
                  isDisabled={loading}
                  placeholder={inputPlaceholder}
                  {...formik.getFieldProps('email')}
                />
              </FormControl>
            </StyledInputWrapper>
          </StyledInputsStack>
          <UnlockSubmitButton
            width={'100%'}
            shape="rounded"
            variant="outline"
            type="submit"
            loading={loading}
          >
            {submitButtonText}
          </UnlockSubmitButton>
        </form>
      </StyledFormStack>
    </StyledContent>
  );
};
